import { BorderColor, Lock, Settings, TrendingUp } from "@mui/icons-material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReactNode } from "react";
import { ACTIVITIES, BASIC_INFO, SECURITY, SETTINGS } from "../../config/constants";

export interface IProfileTab {
    label: string;
    icon: ReactNode;
}

export interface IProfileState {
    profileTabs: IProfileTab[];
    mainProfileTab: IProfileTab | null;
}

const initialState = {
    profileTabs: [
        {
            label: BASIC_INFO,
            icon: <BorderColor />
        },
        {
            label: SECURITY,
            icon: <Lock />
        },
        // {
        //     label: SETTINGS,
        //     icon: <Settings />
        // },
        // {
        //     label: ACTIVITIES,
        //     icon: <TrendingUp />
        // },
    ]
} as IProfileState;

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        setMainProfileTab: (state: IProfileState, action: PayloadAction<IProfileTab | null>) => {
            state.mainProfileTab = action.payload;
        }
    }
});

export const {
    setMainProfileTab
} = profileSlice.actions;

export default profileSlice.reducer;